<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<!--<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    &lt;!&ndash; Navigation header hook &ndash;&gt;
    <ng-container fuseVerticalNavigationContentHeader>
        &lt;!&ndash; Logo &ndash;&gt;
        <div class="flex items-center h-20 p-6">
            &lt;!&ndash; Light version &ndash;&gt;
            <img
                class="dark:hidden w-12"
                src="assets/images/logo/un_logo.png"
                alt="Logo image">
            &lt;!&ndash; Dark version &ndash;&gt;
            <img
                class="hidden dark:flex w-12"
                src="assets/images/logo/un_logo.png"
                alt="Logo image">

            <span class="text-2xl pl-2">United Nations</span>
        </div>
    </ng-container>
</fuse-vertical-navigation>-->


<!-- Wrapper -->
<div [ngClass]="isLtr ? 'flex flex-col flex-auto w-full min-w-0  rtr' : 'flex flex-col flex-auto w-full min-w-0  ltr' " >

    <!-- Header -->
    <nav id="brand-bar" class="navbar navbar-default navbar-fixed-top" role="navigation" >
        <!-- UN global brand bar -->
        <div class="container-fluid brandbar-header language-switcher" [ngClass]="isMobile ? 'wrap' : 'noWrap'" [ngStyle]="isMobile ? {'flex-wrap': 'wrap'} : {'flex-wrap':'nowrap'}">
          <div class="navbar-header">
            <button type="button" (click)="openMenu()" class="navbar-toggle collapsed" data-toggle="collapse"
              data-target="navbar-main" aria-expanded="false" style="margin-left: 15px;">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar increase-mobile-bar"></span>
              <span class="icon-bar increase-mobile-bar"></span>
              <span class="icon-bar increase-mobile-bar"></span>
            </button>

            <button *ngIf="isMobile" class="language-toggler align-self-center btn border-0 gap-0 shadow-none collapsed p-0" type="button" data-bs-toggle="collapse" data-bs-target=".region-top-header-form .block-language" aria-expanded="true">{{getLanguage(currentLang)}}</button>
            <a class="unLink" href="https://www.un.org/" target="_blank">
            <mat-icon style="padding-top: 4px">home</mat-icon>
            <span>{{"Welcome to the United Nations" | translate}}</span></a>

          </div>
          <div class="navbar-collapse collapse geo-margin" [ngClass]="openMobileLang ? 'show' : 'hide'" id="language-switcher" aria-expanded="false"
              >
          <languages></languages>
          </div>
          <a *ngIf="userSigninService.cognitoUtil.getCurrentUser()"
               href="javascript:" (click)="userSigninService.logout()" style="font-size: 14px;line-height: initial;">Logout</a>
        </div><!-- /.container -->
      </nav> <!-- Languages bar -->
      <mobile-languages></mobile-languages>
    <!-- <div class="relative flex flex-0 items-center w-full px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
        style="background: #f2f2f2 !important; height: 41px; border-bottom: #00adef solid 5px;"> -->
        <!-- Navigation toggle button -->
        <!--<button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>-->

        <!--<mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>-->

        <!-- <mat-icon>home</mat-icon>
        <span>Welcome to the United Nations</span> -->



        <!-- Components -->
        <!-- <div id="brand-bar" class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2"> -->
            <!-- <languages></languages> -->
            <!--<fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
            <!--<search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications>-->
            <!--<button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
            </button>-->
            <!--<user></user>-->
            <!-- <a *ngIf="userSigninService.cognitoUtil.getCurrentUser()"
               href="javascript:" (click)="userSigninService.logout()">Logout</a>
        </div>
    </div> -->

    <!-- <div class="flex flex-col flex-auto min-w-0">
        <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-2 sm:px-10 border-b bg-card dark:bg-transparent">
            <div class=" flex flex-wrap items-center font-medium">
                <div>
                    <a class="whitespace-nowrap text-primary-500" [routerLink]="['/']">igov.un.org</a>
                </div>
                <div class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <a class="ml-1 whitespace-nowrap text-primary-500" [routerLink]="['/ga']">GA</a>
                </div>
                <div class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <span class="ml-1 text-secondary">Meetings</span>
                </div>
            </div>
        </div>
    </div> -->

    <!-- <header id="navbar" class="bg-white" role="banner">
          <div class="navbar-header d-inline-flex">
            <a class="logo navbar-btn pull-left flip" [routerLink]="['/']" title="United Nations"></a>
            <span class="navbar-brand pull-left flip" [routerLink]="['/']" title="Shaping our future together">{{title}}</span>
        </div>
    </header> -->

    <header id="navbar" role="banner">
        <div class="flex flex-col flex-auto min-w-0 px-8 pt-4 bg-white h-full">
            <div class="flex flex-wrap overflow-hidden">
                <div [ngClass]="{es: currentLang === 'es',ru: currentLang === 'ru',zh: currentLang === 'zh',en: currentLang === 'en', ar: currentLang === 'ar', fr: currentLang === 'fr', 'navbar-header un-logo my-1 px-1 w-full overflow-hidden sm:my-1 sm:px-1 sm:w-full md:my-2 md:px-2 md:w-1/4 lg:my-2 lg:px-2 lg:w-1/6 xl:my-2 xl:px-2 xl:w-1/5 sm:w-2/6 pb-4': true}">
                <a [routerLink]="['/']" class="logo navbar-btn" >
                </a>
                </div>
                <div class="navbar-header un-title my-1 px-1 w-full overflow-hidden sm:my-8 md:pt-5 sm:px-1 sm:w-full md:my-2 md:px-2 md:w-3/4 lg:my-2 lg:px-2 lg:w-5/6 xl:my-2 xl:px-2 xl:w-4/5 sm:w-4/6">
                <span class="navbar-brand flip " >{{translateService.instant(title)}}</span>
                </div>
            </div>
        </div>

  </header>
  <nav [ngClass]="!isMobile ? 'sticky-top web-header': 'mobile-header'" class="navbar navbar-expand-xl navbar-expand-lg navbar-main p-0" id="navbar-main" data-once="un3_base__main_menu__top" style="background: #f8f9fa;">
            <div class="flex flex-col sm:flex-row flex-0 sm:items-center col-12 sm:justify-between sm:px-10 border-b bg-card dark:bg-transparent" style="padding-right: 0px !important;">
            <div class="navbar-collapse bg-light" id="CollapsingNavbar">

                <!-- <div class="language-switcher-language-url block block-language block-language-block-language-interface block-un3-sc-languageswitcher-2" id="block-un3-sc-languageswitcher-2" role="navigation">

                    <h2 class="block-title">
                                    <a href="#block-un3-sc-languageswitcher-2-content" class="collapsed" data-bs-toggle="collapse">
                        <span class="block-title-collapse">English</span>
                        <span class="block-title-show">Language switcher</span>
                        </a>
                        </h2>

                    <div class="collapse block-content" id="block-un3-sc-languageswitcher-2-content" >
                        <ul class="links nav">
                            <li hreflang="ar" class="ar nav-item">
                                <a href="/securitycouncil/ar" class="language-link nav-link" hreflang="ar">العربية</a>
                            </li>
                            <li hreflang="zh-hans" class="zh-hans nav-item">
                                <a href="/securitycouncil/zh" class="language-link nav-link" hreflang="zh-hans" >中文</a>
                            </li>
                            <li hreflang="en" class="en nav-item is-active" aria-current="page">
                                <a href="/securitycouncil/en" class="language-link nav-link is-active" hreflang="en"  aria-current="page">English</a>
                            </li>
                            <li hreflang="fr" class="fr nav-item">
                                <a href="/securitycouncil/fr" class="language-link nav-link" hreflang="fr" >Français</a>
                            </li>
                            <li hreflang="ru" class="ru nav-item">
                                <a href="/securitycouncil/ru" class="language-link nav-link" hreflang="ru" >Русский</a>
                            </li>
                            <li hreflang="es" class="es nav-item"><a href="/securitycouncil/es" class="language-link nav-link" hreflang="es" >Español</a>
                            </li>
                        </ul>
                    </div>
                </div> -->

                <nav *ngIf="!isMobile" role="navigation" aria-labelledby="block-un3-sc-mainnavigation-2-menu" id="block-un3-sc-mainnavigation-2" class="block block-menu navigation menu--main pt-3">

                    <h2 class="visually-hidden block-title" id="block-un3-sc-mainnavigation-2-menu">
                        <a href="#CollapsingNavbar" data-bs-toggle="collapse">Main navigation</a>
                    </h2>
                    <div class="show block-content">
                        <ul class="clearfix nav mega-nav">

                            <li *ngFor="let menu of igovService.menus(); let i = index" class="nav-item dropdown">
                                <a href="javascript:void(0)"
                                id="dropdownMenuButton{{ i }}"
                                class="nav-link dropdown-toggle"
                                [ngClass]="{ 'active': isActive(menu) }"
                                data-bs-toggle="dropdown"
                                style="min-height: 3.25rem;font-weight: 500;font-size: 16px;"
                                aria-expanded="false">{{menu.title}}</a>
                                <ul class="megamenu dropdown-menu" [attr.aria-labelledby]="'dropdownMenuButton' + i">
                                    <li>
                                        <span class="dropdown-item submenu-item-1">{{menu.title}}</span>
                                        <ul  class="nav megamenu-submenu group-submenu-level-2">
                                            <li *ngFor="let child of menu.child" class="nav-item">
                                                <a *ngIf="child.link.indexOf('https') === -1" [routerLink]="child.link" class="submenu-link submenu-item-2 dropdown-item" [ngClass]="{ 'text-right': !isLtr }" style="padding-left: 0px;">{{child.title}}</a>
                                                <a *ngIf="child.link.indexOf('https') > -1" [href]="child.link" class="submenu-link submenu-item-2 dropdown-item" [ngClass]="{ 'text-right': !isLtr }" style="padding-left: 0px;">{{child.title}}</a>
                                            </li>

                                        </ul>
                                    </li>

                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>

                <mobile-menu *ngIf="openMobileMenu" (onClose)="openMenu()" ></mobile-menu>
            </div>
            </div>
        </nav>
  <!-- <div class="flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">
    <div class="relative flex items-center justify-center h-auto">
        <div class="max-w-12xl w-full p-8 bg-white-100 dark:bg-transparent dark:text-white  h-full">
            <div class="flex">
                <div class="navbar-header">
                    <a class="logo navbar-btn pull-left flip" href="#" title="United Nations"></a>
                    <a class="navbar-brand pull-left flip" href="#" title="Shaping our future together">Schedule of General Assembly Plenary and Related Meetings</a>
                </div>
            </div>
        </div>
    </div>
    </div> -->


    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- <div *ngIf="showBanner" class="banner" style="background-color: #429fdb;direction: ltr;">
            <img src="assets/icons/home-banner.png" style="width: auto;"/>
        </div> -->
        <breadcrumb></breadcrumb>
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden" style="display: inline;">
            <span class="font-medium text-secondary">{{"Department for General Assembly and Conference Management (DGACM)" | translate}} &copy; {{currentYear}}</span>
        <div style="float: right;">
            <ul class="nav list-inline">
                <li class="list-inline-item "><a href="https://www.un.org/en/about-us/copyright" style="text-decoration: none;">{{"Copyright" | translate}}</a></li>
                <li class="list-inline-item "><a href="https://www.un.org/en/about-us/fraud-alert" style="text-decoration: none;">{{"Fraud Alert" | translate}}</a></li>
                <li class="list-inline-item "><a href="https://www.un.org/en/about-us/privacy-notice" style="text-decoration: none;">{{"Privacy Notice" | translate}}</a></li>
                <li class="list-inline-item last"><a href="https://www.un.org/en/about-us/terms-of-use" style="text-decoration: none;">{{"Terms of Use" | translate}}</a></li>
              </ul>
        </div>
        <app-scroll-top></app-scroll-top>
    </div>

</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
